

























import ExpansionProgressPanel from '@/components/ExpansionProgressPanel.vue';
import UserSupportIcon from '@/assets/images/icons/user-support-icon.svg?inline';
import { EOnbordingStep, ERole } from '@/api/schema';
import OnboardingMixin from '@/mixins/Onboarding/OnboardingMixin';
import InviteUserInput from '@/components/invite-user/InviteUserInput.vue';

export default {
  name: 'OnboardingUserSupport',
  mixins: [OnboardingMixin],
  components: {
    ExpansionProgressPanel,
    InviteUserInput,
    UserSupportIcon
  },
  data: (): unknown => ({
    onboardingStepName: EOnbordingStep.userSupportProgress,
    email: ''
  }),
  computed: {
    type(): ERole {
      return this.isCopyStakeAccount
        ? ERole.ROLE_OPERATOR_COPY_STAKE_SUPPORT
        : ERole.ROLE_OPERATOR_SUPPORT;
    },
    getDescriptionTitle(): string {
      return this.isCopyStakeAccount
        ? 'Invite Support Manager to assist with inquiries from CopyStake users.'
        : 'Invite Support Manager to assist with inquiries from Loyalty Program users.';
    }
  },
  methods: {
    handleInvite(): void {
      this.$emit('updateProgress', this.onboardingStepName);
    }
  }
};
